import { Component } from "react";

/**
 * StudentErrorBoundary — catches any render / lifecycle exception in the
 * student quiz tree and shows a friendly recovery card instead of leaving
 * the device on a blank white screen. Reloading rejoins the session and
 * restores the autosaved answers via the standard `load()` path.
 */
export default class StudentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, message: err?.message || "Nieznany błąd" };
  }

  componentDidCatch(err, info) {
    // Best-effort telemetry: log to console so beta testers can copy-paste
    // when reporting. Prod build will still surface it via the boundary UI.
    // eslint-disable-next-line no-console
    console.error("[StudentQuiz crash]", err, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-[#FEE2E2] flex items-center justify-center px-6" data-testid="student-error-boundary">
        <div className="brut border-2 border-[#0F172A] shadow-[6px_6px_0_#0F172A] bg-white rounded-md p-8 max-w-md text-center">
          <div className="text-3xl mb-2" aria-hidden>😳</div>
          <h1 className="font-display font-black text-2xl">Coś się zawiesiło</h1>
          <p className="text-[#334155] mt-3 text-sm">
            Nie martw się — Twoje odpowiedzi są zapisane. Kliknij poniżej,
            żeby wrócić do kartkówki.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="brut brut-hover bg-[#FEF08A] border-2 border-[#0F172A] rounded-md px-4 py-2 font-bold mt-5"
            data-testid="student-error-reload"
          >
            Odśwież stronę
          </button>
          {this.state.message && (
            <details className="mt-4 text-left text-xs text-[#64748B]">
              <summary className="cursor-pointer">Szczegóły techniczne</summary>
              <pre className="mt-2 whitespace-pre-wrap break-all">{this.state.message}</pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
